import { PassiveAbility } from "../../abilities/PassiveAbility";
import { ActiveAbility } from "../../abilities/ActiveAbility";
import { ReactiveAbility } from "../../abilities/ReactiveAbility";
import { SkillRequirement } from "../skills/SkillRequirement";
import { OwnedReference } from "../../Ownership";
import { CharacterAbility } from "../../abilities/Ability";

export type PerkInitializer = {
    id: string;
    name: string;
    description: string;
    icon: string;
    handsAvailableModifier: number;
    skillRequirements: SkillRequirement[];
    actions?: ActiveAbility[];
    reactions?: ReactiveAbility[];
    passives?: PassiveAbility[];
    tags: string[];
}

export const DefaultPerkInitializer: PerkInitializer = {
    id: '',
    name: '',
    description: '',
    icon: 'default',
    handsAvailableModifier: 0,
    skillRequirements: [],
    actions: [],
    reactions: [],
    passives: [],
    tags: []
}

const getActions = (allPerks: PerkInitializer[], reference: OwnedReference): CharacterAbility[] => {
    const perk = allPerks.find(p => p.id == reference.id);
    return (perk?.actions ?? [])
        .map(p => ({
            ...p,
            source: perk!.name
        }));;
}

const getReactions = (allPerks: PerkInitializer[], reference: OwnedReference): CharacterAbility[] => {
    const perk = allPerks.find(p => p.id == reference.id);
    return (perk?.reactions ?? [])
        .map(p => ({
            ...p,
            source: perk!.name
        }));;
}

const getPassives = (allPerks: PerkInitializer[], reference: OwnedReference): CharacterAbility[] => {
    const perk = allPerks.find(p => p.id == reference.id);
    return (perk?.passives ?? [])
        .map(p => ({
            ...p,
            source: perk!.name
        }));
}

const getFeatures = (allPerks: PerkInitializer[], reference: OwnedReference): CharacterAbility[] => {
    return [...getActions(allPerks, reference), ...getPassives(allPerks, reference), ...getReactions(allPerks, reference)];
}

export const PerkHelpers = Object.freeze({
    getActions,
    getReactions,
    getPassives,
    getFeatures,
})